import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setLoading, setSnack } from 'utilities/redux.actions';

export default function* (action) {
    const {
        meta: { handleSubmit = () => {} },
        payload: { formData }
    } = action;

    yield put(setLoading(true));
    try {
        const { data } = yield call(apiRequest, {
            url: 'profile-change-request/apply',
            method: 'post',
            data: formData
        });
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: 'Change request submitted for review',
                type: 'success'
            })
        );
        return handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: error?.response?.data?.message || error?.message,
                type: 'error'
            })
        );
        // keep the dialog open on failure — no success callback
        return null;
    }
}
